import React from 'react';
import { motion } from 'framer-motion';
import { useForm, ValidationError } from '@formspree/react';
import { useLanguage } from '../contexts/LanguageContext';
export function FunctionalSpiceGrid() {
  const {
    t
  } = useLanguage();
  const [state, handleSubmit] = useForm('mkoaalae');
  const spices = [{
    name: t('functional.focus.name'),
    subtitle: t('functional.focus.subtitle'),
    timeEmoji: '☀️',
    spice: t('functional.focus.spice'),
    benefits: t('functional.focus.benefits'),
    description: t('functional.focus.description')
  }, {
    name: t('functional.energy.name'),
    subtitle: t('functional.energy.subtitle'),
    timeEmoji: '🌤️',
    spice: t('functional.energy.spice'),
    benefits: t('functional.energy.benefits'),
    description: t('functional.energy.description')
  }, {
    name: t('functional.calm.name'),
    subtitle: t('functional.calm.subtitle'),
    timeEmoji: '🌙',
    spice: t('functional.calm.spice'),
    benefits: t('functional.calm.benefits'),
    description: t('functional.calm.description')
  }, {
    name: t('functional.rest.name'),
    subtitle: t('functional.rest.subtitle'),
    timeEmoji: '🌑',
    spice: t('functional.rest.spice'),
    benefits: t('functional.rest.benefits'),
    description: t('functional.rest.description')
  }];
  return <section className="w-full py-32 px-6 bg-white" data-id="element-201">
      <div className="max-w-6xl mx-auto" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-203">
          <div className="inline-block px-4 py-1 border border-black text-xs font-mono tracking-wider uppercase mb-6" data-id="element-204">
            {t('functional.badge')}
          </div>
          <h2 className="text-6xl md:text-8xl font-black text-black mb-6 uppercase tracking-tighter leading-none" data-id="element-205">
            {t('functional.title')}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-4" data-id="element-206">
            {t('functional.subtitle')}
          </p>
          <p className="text-sm text-gray-500 max-w-xl mx-auto italic" data-id="element-207">
            {t('functional.pending')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-208">
          {spices.map((spice, index) => <motion.div key={spice.name} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="border-2 border-black p-8 bg-white relative" data-id="element-209">
              <div className="absolute top-4 right-4 text-3xl" data-id="element-210">
                {spice.timeEmoji}
              </div>

              <h3 className="text-3xl font-black mb-1 uppercase tracking-tight" data-id="element-211">
                {spice.name}
              </h3>
              <p className="text-xs text-gray-500 mb-4 uppercase tracking-widest" data-id="element-212">
                {spice.subtitle}
              </p>
              <p className="text-sm text-gray-700 mb-3 uppercase tracking-wider font-medium" data-id="element-213">
                {spice.spice}
              </p>
              <p className="text-xs text-gray-500 mb-4 font-mono" data-id="element-214">
                {spice.benefits}
              </p>
              <p className="text-sm mb-8 leading-relaxed text-gray-800" data-id="element-215">
                {spice.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} id="waitlist" className="scroll-mt-28 border-2 border-black p-8 md:p-12 bg-white" data-id="element-216">
          <div className="text-center mb-8" data-id="element-217">
            <h3 className="text-3xl font-black text-black mb-4 uppercase tracking-tight" data-id="element-218">
              {t('functional.waitlist.title')}
            </h3>
            <p className="text-gray-600 max-w-2xl mx-auto mb-2" data-id="element-219">
              {t('functional.waitlist.description')}
            </p>
            <p className="text-sm text-gray-500 italic" data-id="element-220">
              {t('functional.waitlist.note')}
            </p>
          </div>

          {state.succeeded ? <motion.p initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center text-xl font-black text-black uppercase tracking-wider" role="status" data-id="element-221">
              {t('functional.waitlist.success')}
            </motion.p> : <form onSubmit={handleSubmit} className="max-w-md mx-auto flex flex-col sm:flex-row gap-3" data-id="element-222">
              <div className="flex-1 flex flex-col gap-2" data-id="element-223">
                <input id="email" type="email" name="email" placeholder={t('functional.waitlist.placeholder')} required className="w-full px-6 py-3 bg-black/5 border-2 border-black text-black placeholder-gray-500 focus:outline-none transition-colors font-mono" data-id="element-224" />
                <ValidationError prefix="Email" field="email" errors={state.errors} className="text-xs text-red-600 font-mono" data-id="element-225" />
              </div>
              <button type="submit" disabled={state.submitting} className="px-8 py-3 bg-black text-white font-black hover:bg-gray-800 transition-all duration-200 uppercase tracking-wider text-sm disabled:opacity-50 disabled:cursor-not-allowed self-start" data-id="element-226">
                {state.submitting ? '...' : t('functional.waitlist.cta')}
              </button>
            </form>}
        </motion.div>
      </div>
    </section>;
}